import Http from '@/utils/Http'
import * as utils from '@/utils/Utils'
import StorageUtils from '@/utils/StorageUtils'
import SvgIcon from '@/components/particles/SvgIcon'
import HeadUtils from '@/components/HeadUtils'
import Breadcrumb from '@/components/particles/Breadcrumb'
import Modal from '@/components/Modal'
import Ibox from '@/components/particles/Ibox'
import FieldMessage from '@/components/particles/FieldMessage'
import flatpickr from 'flatpickr'
import {Portuguese} from 'flatpickr/dist/l10n/pt'
import money from 'v-money'
import VueTheMask from 'vue-the-mask'

export default {
    install(Vue/*, options*/) {
        Vue.prototype.$appHttp = Http;
        Vue.prototype.$appUtils = utils;
        Vue.prototype.$appStorage = StorageUtils;

        Vue.component('svg-icon', SvgIcon);
        Vue.component('breadcrumb', Breadcrumb);
        Vue.component('head-utils', HeadUtils);
        Vue.component('modal', Modal);
        Vue.component('ibox', Ibox);
        Vue.component('field-messages', FieldMessage);

        Vue.use(money, {precision: 2, thousands: '.', decimal: ','});
        Vue.use(VueTheMask);

        Vue.filter('formatPhone', utils.formatPhone);
        Vue.filter('formatDocument', utils.formatDocument);
        Vue.filter('formatPostalCode', utils.formatPostalCode);
        Vue.filter('formatDate', utils.formatDate);
        Vue.filter('formatDateHourMin', value => utils.formatDate(value, 'DD/MM/YYYY H:mm'));
        Vue.filter('formatMoney', utils.formatMoney);
        Vue.filter('formatNumber', utils.formatNumber);
        Vue.filter('humanizeNumber', utils.humanizeNumber);
        Vue.filter('bool2Human', value => !!value ? 'Sim' : 'Não');
        Vue.filter('changeCase', (val, type) => {
            if (utils.isEmpty(val)) return val;

            switch (type) {
                case 'capitalize':
                    return val.capitalize();
                case 'uppercase':
                    return val.toUpperCase();
                case 'downcase':
                default:
                    return val.toLowerCase()
            }
        });

        Vue.directive('flatpickr', {
            bind(el, binding) {
                const defaultConfig = {locale: Portuguese, dateFormat: 'd/m/Y', allowInput: true, disableMobile: true};
                el.autocomplete = 'off';
                flatpickr(el, {...defaultConfig, ...(binding && binding.value ? binding.value : {})});
            },
            unbind(el) {
                if(el._flatpickr) el._flatpickr.destroy();
            }
        });

        let handleOutsideClick;

        Vue.directive('closable', {
            bind (el, binding, vnode) {
                handleOutsideClick = (e) => {
                    e.stopPropagation();
                    const { handler, exclude } = binding.value;
                    let clickedOnExcludedEl = false;
                    exclude.forEach(refName => {
                        if (!clickedOnExcludedEl) {
                            const excludedEl = vnode.context.$refs[refName];
                            if (excludedEl) clickedOnExcludedEl = excludedEl.contains(e.target)
                        }
                    });

                    if (!el.contains(e.target) && !clickedOnExcludedEl) {
                        vnode.context[handler]()
                    }
                };
                document.addEventListener('click', handleOutsideClick);
                document.addEventListener('touchstart', handleOutsideClick)
            },
            unbind () {
                document.removeEventListener('click', handleOutsideClick);
                document.removeEventListener('touchstart', handleOutsideClick)
            }
        });


        function $rippleListener(e) {
            const d = Math.max(this.clientWidth, this.clientHeight);
            const divContainer = document.createElement('div');
            divContainer.style.overflow = 'hidden';
            divContainer.style.position = 'absolute';
            divContainer.style.width = '100%';
            divContainer.style.height = '100%';
            divContainer.style.top = '0';
            divContainer.style.left = '0';
            divContainer.style.right = '0';
            divContainer.style.bottom = '0';


            const div = document.createElement('div');
            divContainer.appendChild(div);

            const rect = this.getBoundingClientRect();

            div.classList.add('ripple-effect');
            div.style.width = div.style.height = `${d}px`;
            div.style.left = `${e.clientX - rect.left - d / 2}px`;
            div.style.top = `${e.clientY - rect.top - d / 2}px`;

            this.appendChild(divContainer);
            const s = this;
            setTimeout(() => {s.removeChild(divContainer)}, 301);
        }

        Vue.directive('ripple-tap', {
            bind (el) {
                el.style.position = 'relative';
                el.addEventListener('click', $rippleListener);
            },
            unbind(el) {
                el.removeEventListener('click', $rippleListener);
            }
        });

        Array.prototype.indexById = function (obj) {
            let compare = null;
            if (obj.id) compare = 'id';
            else if (obj._id) compare = '_id';

            if (!compare) return -1;

            for (let i = 0; i < this.length; i++)
                if (this[i][compare] && this[i][compare] === obj[compare]) return i;
            return -1;
        };

        Array.prototype.findById = function (id) {
            const idx = this.indexById({id: id});
            return idx > -1 ? this[idx] : null;
        };

        Array.prototype.isEmpty = function () {
            return this.length === 0;
        };

        Array.prototype.isNotEmpty = function () {
            return !this.isEmpty();
        };

        Array.prototype.changeObject = function (obj) {
            let idx = this.indexById(obj);
            if (idx > -1) {
                this[idx] = obj;
                return true;
            }
            return false;
        };
        Array.prototype.pushOrChange = function (obj) {
            if (!this.changeObject(obj)) this.push(obj);
        };
        Array.prototype.deleteObject = function (obj) {
            let idx = this.indexById(obj);
            if (idx > -1) return this.splice(idx, 1);
            return false;
        };

        String.prototype.decapitalize = function() {
            return this.charAt(0).toLowerCase() + this.slice(1);
        };

        String.prototype.capitalize = function(lowercaseRest = false) {
            const remainingChars = !lowercaseRest ? this.slice(1) : this.slice(1).toLowerCase();

            return this.charAt(0).toUpperCase() + remainingChars;
        };

        String.prototype.camelize = function(decapitalize = false) {
            const str = this.trim().replace(/[-_\s]+(.)?/g, function(match, c) {
                return c ? c.toUpperCase() : '';
            });

            return decapitalize ? str.decapitalize(decapitalize) : str;
        };

        String.prototype.underscored = function() {
            return this.trim().replace(/([a-z\d])([A-Z]+)/g, '$1_$2').replace(/[-\s]+/g, '_').toLowerCase();
        };

        String.prototype.replaceTags = function() {
            return utils.replaceTags(this);
        };

        String.prototype.trunc = function(n){
            if (utils.isEmpty(this)) return this;
            return this.substr(0,n-1)+(this.length>n?'&hellip;':'');
        };

        String.prototype.containsStr = function(str, ignoreCase = true, ignoreNull = true){

            if (utils.isEmpty(str) && ignoreNull) return true;

            if (ignoreCase) return this.toLowerCase().trim().indexOf(str.trim().toLowerCase()) > -1;

            return this.trim().indexOf(str.trim()) - 1;
        };

        String.prototype.extenso = function (c, isF) {
            const ex = [
                ["zero", "um", "dois", "três", "quatro", "cinco", "seis", "sete", "oito", "nove", "dez", "onze", "doze", "treze", "quatorze", "quinze", "dezesseis", "dezessete", "dezoito", "dezenove"],
                ["dez", "vinte", "trinta", "quarenta", "cinqüenta", "sessenta", "setenta", "oitenta", "noventa"],
                ["cem", "cento", "duzentos", "trezentos", "quatrocentos", "quinhentos", "seiscentos", "setecentos", "oitocentos", "novecentos"],
                ["mil", "milhão", "bilhão", "trilhão", "quadrilhão", "quintilhão", "sextilhão", "setilhão", "octilhão", "nonilhão", "decilhão", "undecilhão", "dodecilhão", "tredecilhão", "quatrodecilhão", "quindecilhão", "sedecilhão", "septendecilhão", "octencilhão", "nonencilhão"]
            ];

            if (isF) {
                ex[0][1] = "uma";
                ex[0][2] = "duas";
                ex[2] = ["cem", "cento", "duzentas", "trezentas", "quatrocentas", "quinhentas", "seiscentas", "setecentas", "oitocentas", "novecentas"];
            }

            let a = null;
            let n = this.replace(c ? /[^,\d]/g : /\D/g, "").split(",");
            let v = null;
            let i = null;
            let e = " e ";
            let $ = "real";
            let d = "centavo";
            let sl = null;

            for (var f = n.length - 1, l, j = -1, r = [], s = [], t = ""; ++j <= f; s = []) {
                j && (n[j] = (("." + n[j]) * 1).toFixed(2).slice(2));
                if (!(a = (v = n[j]).slice((l = v.length) % 3).match(/\d{3}/g), v = l % 3 ? [v.slice(0, l % 3)] : [], v = a ? v.concat(a) : v).length) continue;
                for (a = -1, l = v.length; ++a < l; t = "") {
                    if (!(i = v[a] * 1)) continue;
                    i % 100 < 20 && (t += ex[0][i % 100]) ||
                    i % 100 + 1 && (t += ex[1][(i % 100 / 10 >> 0) - 1] + (i % 10 ? e + ex[0][i % 10] : ""));
                    s.push((i < 100 ? t : !(i % 100) ? ex[2][i === 100 ? 0 : i / 100 >> 0] : (ex[2][i / 100 >> 0] + e + t)) +
                        ((t = l - a - 2) > -1 ? " " + (i > 1 && t > 0 ? ex[3][t].replace("ão", "ões") : ex[3][t]) : ""));
                }
                a = ((sl = s.length) > 1 ? (a = s.pop(), s.join(" ") + e + a) : s.join("") || ((!j && (n[j + 1] * 1 > 0) || r.length) ? "" : ex[0][0]));
                a && r.push(a + (c ? (" " + (v.join("") * 1 > 1 ? j ? d + "s" : (/0{6,}$/.test(n[0]) ? "de " : "") + $.replace("l", "is") : j ? d : $)) : ""));
            }

            return r.join(e);
        };
    }
}
